<div class="modal-content">
    <div class="modal-header">
        <h3 class="fzas-modal-title m-0">Editar Analista</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"(click)="salir(false)"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="nuevoCentroForm">
            <div class="row">
                <div class="col-8">
                    <label for="centroCodigoCompania" class="form-label fzas-text-input">ID Centro</label>
                    <input type="text" formControlName="centroCodigoCompania" name="centroCodigoCompania" placeholder="Sin ID del Centro" class="form-control"/>
                </div>
                <div class="col-4">
                    <label for="centroIniciales" class="form-label fzas-text-input">Iniciales Centro</label>
                    <input type="text" formControlName="centroIniciales" name="centroIniciales" placeholder="Sin Iniciales" class="form-control"/>
                </div>
            </div>
            <div class="col-12 mt-3">
                <label for="centroNombre" class="form-label fzas-text-input">Nombre Centro</label>
                <input type="text" formControlName="centroNombre" name="centroNombre" placeholder="Sin Nombre Centro" class="form-control"/>
            </div>
            <div class="row">
                <div class="col-6 mt-3">
                    <label for="centroSociedad" class="form-label fzas-text-input">Sociedad</label>
                    <input type="text" formControlName="centroSociedad" name="centroSociedad" placeholder="Sin Sociedad Seleccionada" class="form-control"/>
                </div>
                <div class="col-6 mt-3">
                    <label for="centroSegmento" class="form-label fzas-text-input">Segmento</label>
                    <input type="text" formControlName="centroSegmento" name="centroSegmento" placeholder="Sin Segmento Seleccionado" class="form-control"/>
                </div>
            </div>
            <!-- <div class="col-12 mt-3">
                <label for="centroCentroCosto" class="form-label fzas-text-input">Centro de Costo</label>
                <input type="text" formControlName="centroCentroCosto" name="centroCentroCosto" placeholder="Sin Centro de Costo Seleccionado" class="form-control"/>
            </div> -->
            <div class="col-12 mt-3">
                <label for="centroAnalistaFzas" class="form-label fzas-text-input">Analista Finanzas</label>
                <p-autoComplete formControlName="centroAnalistaFzas" [suggestions]="analistasFiltrados" (completeMethod)="buscarAnalistas($event)" (onSelect)="onSelectAnalista($event)" field="name"></p-autoComplete>
                <small *ngIf="verErrorAnalistas" class="text-danger">No se encontraron resultados para el nombre ingresado.</small>
            </div>
            <div class="col-12 mt-3">
                <label for="flexSwitchCheckDefault" class="form-label fzas-text-input">Activación centro</label>
                <div class="form-switch d-flex align-items-center gap-2">
                    <input class="form-check-input mb-1" type="checkbox" role="switch" id="flexSwitchCheckDefault" formControlName="centroActivacion">
                    <label class="form-check-label ms-1" for="flexSwitchCheckDefault" [ngClass]="switchLabel == 'Activado' ? 'fzas-switch-modal-blue' : 'fzas-switch-modal-grey'">{{ switchLabel }}</label>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12 d-flex justify-content-end gap-3">
                <button type="button" class="btn btn-cancelar-accion" (click)="salir(false)">Cancelar</button>
                <button type="button" class="btn btn-aplicar-accion" (click)="aceptar()">Aceptar</button>
            </div>
        </div>
    </div>
</div>